<script setup lang="ts">
withDefaults(defineProps<{
  debug?: boolean
  dir?: 'ltr' | 'rtl'
  contentCenter?: boolean
}>(), { 
  debug: false,
  dir: 'ltr',
  contentCenter: true
})
</script>

<template>
<Frame class="m-frame frame-service-sphere" :class="[{ debug }, dir]" 
w="grid grid-cols-[1fr] g-1 t:g-2 ds:grid-cols-[100px_1fr_100px] ds:g-1">
  <Frame class="col-left" w="">
    <slot name="left">
      
    </slot>
  </Frame>
  <Frame class="col-content" :class="[{ 'grid items-center': contentCenter }]" w="">
    <slot name="content">
      
    </slot>
  </Frame>
  <Frame class="col-right" w="">
    <slot name="right">
      
    </slot>
  </Frame>
</Frame>
</template>

<style lang="scss" scoped>
.m-frame {
  &.frame-service-sphere {

    .col-left {
      
    }

    .col-content {
      
    }

    .col-right {
      
    }

    // &.ltr {

    //   :deep(>.m-wrap) {
    //     @include mq($from: t) {
    //       @apply grid-cols-[100px_1fr_100px];
    //     }
    //   }
    
    //   .col-icon {
    //     order: 1;
    //   }
    //   .col-statement {
    //     order: 2;
    //   }
    // }

    // &.rtl {

    //   :deep(>.m-wrap) {
    //     @include mq($from: t) {
    //       @apply grid-cols-[1fr_100px];
    //     }
    //   }
     
    //   .col-icon {
    //     order: 2;
    //   }
    //   .col-statement {
    //     order: 1;
    //   }
    // }

  }

  &.debug {
    box-shadow: inset 0 0 0 1px red;

    :deep(>.m-wrap) {
      box-shadow: inset 0 0 0 1px blue;

      .col-left {
        box-shadow: inset 0 0 0 1px cyan;
        >.m-wrap {
          box-shadow: inset 0 0 0 1px lightcyan;
        }
      }
      .col-right {
        box-shadow: inset 0 0 0 1px magenta;
        >.m-wrap {
          box-shadow: inset 0 0 0 1px pink;
        }
      }
      .col-content {
        box-shadow: inset 0 0 0 1px yellow;
        >.m-wrap {
          box-shadow: inset 0 0 0 1px lightyellow;
        }
      }
    }
  }
}
</style>